import { __rest } from "tslib";
import * as React from 'react';
import { classes, st } from './Image.deprecated.st.css';
import { WowImage } from '../WowImage/WowImage';
/** Image is a component to literally display an image - whether an absolute with full URL or a media platform item with relative URI */
export class Image extends React.Component {
    render() {
        const _a = this.props, { className } = _a, imageProps = __rest(_a, ["className"]);
        return React.createElement(WowImage, Object.assign({ className: st(classes.root, className) }, imageProps));
    }
}
//# sourceMappingURL=Image.js.map